import { useQuery } from 'react-query';

import { getTrapDetailPiePeriodsChartData } from 'api/traps/Trap/getTrapDetailPiePeriodsChartData';
import { TrapType } from 'components/AnalyticsPage/TrapType';

export const useGetTrapDetailPiePeriodsChartData = (slug: string, trapType: TrapType) => {
  const { data, isLoading, isFetching } = useQuery(
    ['TrapDetailPiePeriodsChartData', slug, trapType],
    () => getTrapDetailPiePeriodsChartData(slug, trapType),
    {
      refetchOnWindowFocus: false,
    },
  );

  return { data, isLoading, isFetching };
};
